export default "__VITE_ASSET__bb1e59f9__"